(function () {
  'use strict';
  if (!window.LDO_FITMENT_V5 || !window.LDO_FITMENT_V5.products) return;

  var products = window.LDO_FITMENT_V5.products;
  var gmMirrorFits = [
    [2014, 2018, 'Chevrolet', 'Silverado 1500', 'H'],
    [2014, 2018, 'GMC', 'Sierra 1500', 'H'],
    [2015, 2019, 'Chevrolet', 'Silverado 2500HD', 'H'],
    [2015, 2019, 'Chevrolet', 'Silverado 3500HD', 'H'],
    [2015, 2019, 'GMC', 'Sierra 2500HD', 'H'],
    [2015, 2019, 'GMC', 'Sierra 3500HD', 'H']
  ];

  function gmMirrorRecord(title) {
    return {
      c: 'vehicle_conditional',
      y: 'Tow Mirrors',
      t: title,
      f: gmMirrorFits.map(function (fit) { return fit.slice(); }),
      x: ['Confirm your truck’s existing mirror connector and factory mirror features before ordering'],
      z: ['Confirm your truck’s existing mirror connector and factory mirror features before ordering'],
      r: {}
    };
  }

  // Live Shopify handles omitted from the Aug. 14 V15/V18 fitment snapshot.
  products['new-style-gmc-chevy-tow-mirrors'] = gmMirrorRecord(
    '2014-2018 Silverado/Sierra 1500/2500/3500 Tow Mirrors (Black or Chrome) - Power/Heat/Signal/Cargo/Running/Temp Sensor'
  );
  products['new-style-switchback-sequential-chevy-silverado-gmc-sierra-tow-mirrors-2014-2018'] = gmMirrorRecord(
    '2014-2018 Sequential Switchback Silverado/Sierra 1500/2500/3500 Tow Mirrors'
  );
})();
